import Fetch from 'fetch';
import defaultBranding from './defaultModernBranding.json';

export default {
    getModernBranding(diId) {
        const { pathname } = window.location;
        let region = 'live';

        if (pathname.indexOf('/beta/') !== -1) {
            region = 'beta';
        }

        const url = `/nxg-olb-bff/${region}/nxg-ui/v1/brandings`;
        // const url = '/nxg-ui/v1/brandings';

        return Fetch.get(url, { type: 'legacy' }, { institutionId: diId })
            .then((data) => {
                return data.themes.light;
            })
            .catch((err) => {
                console.error(err);

                return defaultBranding;
            });
    },
};
